import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { CommonWrapper } from '../SharedStyles'

const BOTShopByBrandMessage = ({ placeholders: { link = []}}) =>
  <Wrapper>
    <Message>
      <span data-at-shop-by-brand-label>You can also shop by </span>
      { link.map(link => React.cloneElement(link, { 'data-at-shop-by-brand-link': true })) }
    </Message>
  </Wrapper>

BOTShopByBrandMessage.propTypes = {
  placeholders: PropTypes.shape({
    link: PropTypes.array
  })
}

BOTShopByBrandMessage.type = 'BOTShopByBrandMessage'
BOTShopByBrandMessage.placeholders = ['link']

export default BOTShopByBrandMessage

const Wrapper = styled(CommonWrapper)`
  position: relative;
  ${Mixin.responsive('padding', '0 10px', '15px 0')}
`

const Message = styled.div`
  text-align: right;
  font-weight: 600;

  & a {
    font-weight: 600;
    text-decoration: none;
  }

  & a:hover {
    text-decoration: underline;
  }
`
